import React, { useImperativeHandle, forwardRef, useRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from "react-toastify";
import uuid from 'react-uuid';
import { Modal } from 'bootstrap';
import HttpAPICall from '../../services/HttpAPICall';
import { IAM_API_BASE_URL_2 } from '../../services/TapApiUrls';
import TapIcon from '../../services/TapIcon';


const EditBudgetModal = forwardRef((props, ref) => {

    const budgetEditUrl                     =   IAM_API_BASE_URL_2 + '/project/budget_update';
    
    const [modalId, setModalId]             =   useState(uuid());
    const modalElem                         =   useRef(null);
    const modal                             =   useRef(null);
    const access_token                      =   useSelector(state => state.auth.access_token);

    const initialData                       =   {
        id                  :   '',
        budget              :   '',
    }

    const [formSubmitting, setFormSubmitting]   =   useState(false);
    const [editData, setEditData]               =   useState(initialData);


    useImperativeHandle(ref, () => ({
        initHandler: (projectDetails) => {
            if(projectDetails) {
                setEditData({
                    id                  :   projectDetails.id,
                    budget              :   projectDetails.budget,
                });
                openModalHandler();
            }

        }
    }));
    useEffect(() => {
        modalElem.current = document.getElementById(modalId);
        modal.current = new Modal(modalElem.current, { keyboard: false, backdrop: false });
        // Cleanup on unmount
        return () => {
            if (modal.current) {
                modal.current.dispose();
            }
        };
    }, []);
    const modalOpen                         =   ()  => {
        if (modal.current) { modal.current.show(); }
    }
    const modalClose                        =   ()  => {
        setEditData(initialData)
        if (modal.current) { modal.current.hide(); }
    }

  

   

    const openModalHandler        =    ()  =>  {
        modalOpen();
    }

    const handleOnChange    =   (e) => {    
        setEditData(pre => ({...pre, [e.target.name] : e.target.value}))
    }

    const submitHandler =   (e)  => {
        e.preventDefault();
        console.log(editData);
        
        if(editData.id) {
            setFormSubmitting(true)
            HttpAPICall.withAthorization('PUT', budgetEditUrl, access_token, null, editData, (response) => {
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                props.getProjectDetail();
                modalClose();
            })
            .then(() => setFormSubmitting(pre => !pre))

        }else {
            toast.error('Something went wrong. You cannot edit the Budget.')
        }
        
    }   
 
    return <>
        <div className="modal fade" id={modalId} tabIndex="-1" ref={modalElem}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Update Budget</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={modalClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="modal-body">
                        
                            <form id="editBudget" onSubmit={submitHandler}>
                                <div className="row mb-3">
                                    <div className='col-sm-3 '>
                                        <label className="col-form-label ">Budget</label>
                                    </div>
                                    <div className="col-sm-7 mb-2">
                                        <input
                                            name='budget'
                                            type="number"
                                            className="form-control"
                                            autoComplete="off"
                                            value={editData.budget}
                                            onChange={handleOnChange}
                                            placeholder="Enter Budget"
                                        />
                                    </div>

                                </div>
                            </form>
                        
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" disabled={formSubmitting } onClick={modalClose}>Close</button>
                            <button type="submit" form='editBudget' className="btn btn-primary" disabled={formSubmitting} >Save {formSubmitting && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
});

export default EditBudgetModal;

